<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/giftpackagedetails/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
    >
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="礼包名称">
        <el-select v-model="formModel.giftId">
          <el-option
            v-for="item in giftIdType"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="来源">
        <el-select v-model="formModel.sourceType">
          <el-option
            v-for="item in sourceType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="生效时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="formModel.time1"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="agentId"
        label="代理商ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentName"
        label="代理商姓名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentPhone"
        label="代理商手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="giftName"
        label="礼包名称"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column
      ><el-table-column
        prop="orderNo"
        label="订单号"
        min-width="300"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="sourceType"
        label="来源"
        :formatter="formatterTablesourceType"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="sourceId"
        label="划拨代理商ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="machineNum"
        label="机具数量"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="residueNum"
        label="剩余数量"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="生效时间"
        :formatter="formatterTableData"
        min-width="200"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.startTime + " ~ " + scope.row.endTime }}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTablestatus"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="260"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        v-if="hasPerm('/giftpackagedetails/caozuo')"
        label="操作"
        min-width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="openAddDialog(scope.row)"
            >划拨
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      formDialogTitle="划拨"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="120px"
      dialogWidth="439px"
    >
      <el-form-item label="目标代理商ID" prop="targetAgentId">
        <el-input
          type="text"
          v-model="dialogModel.targetAgentId"
          placeholder="请输入"
          style="width: 234px"
        ></el-input>
      </el-form-item>
      <div class="flex-row vertical-center mem-name">
        <p>代理商姓名：</p>
        <p v-if="memName.phoneNumber">
          {{
            memName.realName || memName.nickName || "用户" + memName.phoneNumber
          }}
        </p>
      </div>
      <el-form-item label="礼包" prop="targetGiftId">
        <el-select v-model="dialogModel.targetGiftId">
          <el-option
            v-for="item in giftIdType.slice(1, giftIdType.length)"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="dialogModel.remark"
          maxlength="200"
          show-word-limit
          type="textarea"
          rows="3"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import ShopService from "service/ShopService";
import FormDialog from "../../dialog/FormDialog";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "giftpackagedetails",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      formModel: {
        userId: "",
        giftId: "",
        sourceType: "",
        time: "",
        time1: "",
        operationDirection: "",
      },
      itemId: "",
      agentId: "",
      memName: {},
      dialogModel: {
        targetAgentId: undefined,
        targetGiftId: "",
        remark: "",
      },
      dialogRules: {
        targetAgentId: [
          {
            required: true,
            validator: this.validateTargetAgentId,
          },
        ],
        remark: [
          {
            required: true,
            message: "请输入",
          },
        ],
        targetGiftId: [
          {
            required: true,
            message: "请选择",
          },
        ],
      },
      giftIdType: [
        {
          id: "",
          name: "全部",
        },
      ],
      sourceType: [
        {
          dictKey: "",
          dictValue: "全部",
        },
        {
          dictKey: "1",
          dictValue: "购买",
        },
        {
          dictKey: "2",
          dictValue: "上级划拨",
        },
        {
          dictKey: "3",
          dictValue: "人工",
        },
      ],
      status: [
        {
          dictKey: "",
          dictValue: "全部",
        },
        {
          dictKey: "0",
          dictValue: "未生效",
        },
        {
          dictKey: "1",
          dictValue: "使用中",
        },
        {
          dictKey: "2",
          dictValue: "过期",
        },
      ],
      tableData: [],
      submitService: ShopService.giftpackagedetailsList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      if (this.formModel.time1 == null || this.formModel.time1 == "") {
        this.formModel.time1 = [];
      }
      const params = {
        userId: this.formModel.userId,
        giftId: this.formModel.giftId,
        sourceType: this.formModel.sourceType,
        status: this.formModel.status,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.time.length) {
        params.validStart = this.formModel.time[0];
        params.validEnd = this.formModel.time[1];
      }
      if (this.formModel.time1.length) {
        params.createStart = this.formModel.time1[0];
        params.createEnd = this.formModel.time1[1];
      }
      return params;
    },
    dialogData() {
      const params = {
        targetAgentId: this.dialogModel.targetAgentId,
        targetGiftId: this.dialogModel.targetGiftId,
        remark: this.dialogModel.remark,
      };
      if (this.itemId) {
        params.sourceGiftId = this.itemId;
      }
      return params;
    },
    dialogService() {
      return ShopService.giftpackagedetailsEdit;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        time: "",
        time1: "",
        giftId: "",
        sourceType: "",
        status: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getgiftIdType();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getgiftIdType() {
      this.doLoad(
        ShopService.giftpackmanageList,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.giftIdType = [...this.giftIdType, ...res.contents.rows];
          });
        },
        "信息获取失败"
      );
    },
    gettargetAgentId(val, onSuccess) {
      const params = {
        sourceId: this.agentId,
        targetId: val,
      };
      this.doLoad(
        ShopService.gettargetAgentId,
        params,
        (res) => {
          onSuccess && onSuccess(res);
        },
        "信息获取失败"
      );
    },
    openAddDialog(item, flag) {
      console.log(item);
      this.itemId = item ? item.id : "";
      this.memName = {};
      if (this.itemId) {
        this.isFlag = true;
        this.agentId = item.agentId;
      }
      this.$refs.formDialog.open();
    },

    dialogClose() {
      this.dialogModel = {
        targetAgentId: undefined,
        targetGiftId: "",
        remark: "",
      };
      this.itemId = "";
      this.agentId = "";
      this.memName = {};
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    formatterTablesourceType(row, column, cellValue, index) {
      let value = "--";
      this.sourceType.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    formatterTablestatus(row, column, cellValue, index) {
      let value = "--";
      this.status.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    validateTargetAgentId(rule, value, callback) {
      if (!value) {
        return callback(new Error("请输入"));
      }
      if (!/^\d+$/.test(value)) {
        return callback(new Error("请输入纯数字"));
      }
      this.gettargetAgentId(value, (res) => {
        if (res.contents == null) {
          this.memName = "";
          return callback(new Error("查询不到此代理商"));
        }
        if (res.contents.dealerFlag === 0) {
          return callback(new Error("此代理商不是经销商"));
        }
        this.memName = res.contents;
        callback();
      });
    },
  },
};
</script>

<style scoped>
p {
  font-size: 14px;
  color: #000;
  font-weight: bold;
  margin-bottom: 30px;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 106px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/ShopManagement/GiftPackageDetails.vue